<script>
import axios from "axios";
export default {
  data() {
    return {
      loader: false,
      curr: {},
      attGraphData: {},
      chartData: {
        series: [
          {
            name: "Current",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
          {
            name: "Previous",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
        chartoptions: {
          chart: {
            height: 350,
            type: "area",
            toolbar: {
              show: false,
            },
            zoom: {
              enabled: false,
            },
          },
          colors: ["#556ee6", "#34c38f"],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 2,
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.45,
              opacityTo: 0.05,
              stops: [20, 100, 100, 100],
            },
          },
          xaxis: {
            categories: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
          },
          markers: {
            size: 3,
            strokeWidth: 3,

            hover: {
              size: 4,
              sizeOffset: 2,
            },
          },
          legend: {
            position: "top",
            horizontalAlign: "right",
          },
        },
      },
      selection: "all",
    };
  },
  props: ['dataProp'],
  methods: {
    async getAttAnalysisGraph() {
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_att_analysis_graph_data", {
          params: { empId: this.curr.empId, companyId: this.curr.companyId },
        });
         if(response.data.success == "true") {
          this.attGraphData = response.data.data;

          for(var i = 0;i < this.attGraphData.currYear.length;i++) {
            this.chartData.series[0].data[i] = this.attGraphData.currYear[i].avgAttendance;
          }

          for(i = 0;i < this.attGraphData.prevYear.length;i++) {
            this.chartData.series[1].data[i] = this.attGraphData.prevYear[i].avgAttendance;
          }
          window.dispatchEvent(new Event("resize"));
        }
      } catch (error) {
        //console.log(error);
      }
    },
    updateData: function() {
      this.chartData.series = [
        {
          name: "Current",
          data: [18, 21, 45, 36, 65, 47, 51, 32, 40, 28, 31, 26],
        },
        {
          name: "Previous",
          data: [30, 11, 22, 18, 32, 23, 58, 45, 30, 36, 15, 34],
        },
      ];
    },
  },
  created() {
    this.curr = this.dataProp;
    this.getAttAnalysisGraph();
  },
  mounted() {
    window.dispatchEvent(new Event('resize'));
  },
};
</script>

<template>
  <div class="card-body">
    <div class="is-loading">
        <div class="preloader-component" v-show="loader">
          <div class="status">
            <div class="spinner-chase">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
    <div class="d-flex flex-wrap">
      <h5 class="card-title me-2">{{ $t('menuitems.attendance.analysis') }}</h5>
      
      <div class="ms-auto">
        <div class="toolbar button-items text-end">
          <!--<button
            type="button"
            class="btn btn-light btn-sm"
            @click="updateData('all')"
            :class="{ active: selection === 'all' }"
          >
            ALL
          </button>
          <button
            type="button"
            class="btn btn-light btn-sm"
            @click="updateData('one_month')"
            :class="{ active: selection === 'one_month' }"
          >
            1M
          </button>
          <button
            type="button"
            class="btn btn-light btn-sm"
            @click="updateData('six_months')"
            :class="{ active: selection === 'six_months' }"
          >
            6M
          </button>-->
          <!--<button
            type="button"
            class="btn btn-light btn-sm active"
            @click="updateData()"
          >
            {{ $t('menuitems.attendance.reset') }}
          </button>-->
        </div>
      </div>
    </div>

    <!--<div class="row text-center">
      <div class="col-lg-4">
        <div class="mt-4">
          <p class="text-muted mb-1">Today</p>
          <h5>1024</h5>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="mt-4">
          <p class="text-muted mb-1">This Month</p>
          <h5>
            12356
            <span class="text-success font-size-13"
              >0.2 % <i class="mdi mdi-arrow-up ms-1"></i
            ></span>
          </h5>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="mt-4">
          <p class="text-muted mb-1">This Year</p>
          <h5>
            102354
            <span class="text-success font-size-13"
              >0.1 % <i class="mdi mdi-arrow-up ms-1"></i
            ></span>
          </h5>
        </div>
      </div>
    </div>-->

    <!--<hr class="mb-4" /> -->

    <apexchart
      class="apex-charts"
      dir="ltr"
      height="400"
      :series="chartData.series"
      :options="chartData.chartoptions"
    ></apexchart>
    </div>
  </div>
</template>


<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>